import React, { useState, useEffect, useRef, useContext } from 'react';
import { toast } from 'react-toastify';
import './style.css';
import centralAPI from '../../../CentralAPIHandler/CentralAPIHandler';
import { amplitudeEvents } from '../../../utils/utilityFunctions';
import { MediaContext } from '../context';

const ShareModal = ({ onClose, downloadEnabled }) => {
    const { skuName, enterpriseId, dealerVinId } = useContext(MediaContext);
    const [isVisible, setIsVisible] = useState(false);
    const [shareLink, setShareLink] = useState(window.location.href);
    const [vehicleImage, setVehicleImage] = useState('https://spyne-static.s3.us-east-1.amazonaws.com/console/InputContainer.png');
    const [vinData, setVinData] = useState(skuName);
    const [carName, setCarName] = useState('Demo Car');
    const [clientHeight, setClientHeight] = useState(window.innerHeight);
    const [loading, setLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownload, setIsDownload] = useState(downloadEnabled);
    const [copied, setIsCopied] = useState(false);
    const [shareCount, setShareCount] = useState(0);
    const [isHidden, setIssHidden] = useState(false);


    const url = window.location.href;
    // const progressIntervalRef = useRef(null);


    useEffect(() => {
        const handleResize = () => {
            setClientHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 10);
        return () => {
            // if (progressIntervalRef.current) {
            //     clearInterval(progressIntervalRef.current);
            // }
            clearTimeout(timer);
        }
    }, [shareCount]);




    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                if(dealerVinId && dealerVinId !== ''){
                    URL= `${process.env.REACT_APP_BASEURL_API_SPYNE}/inventory/v2/vins/details?dealerVinId=${dealerVinId}`
                }else if(enterpriseId && enterpriseId !== '' && skuName && skuName !== ''){
                    URL= `${process.env.REACT_APP_BASEURL_API_SPYNE}/inventory/v1/vins/details?enterpriseId=${enterpriseId}&vin=${skuName}`
                }
            
                const response = await fetch(URL, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    // console.log(data,"data");
                    // await new Promise((resolve) => setTimeout(resolve, 2400));

                    if (data?.data?.thumbnail_output_url || data?.data?.thumbnailUrl || data?.data?.year || data?.data?.make || data?.data?.model) {
                        setVehicleImage(data?.data?.thumbnail_output_url || data?.data?.thumbnailUrl);
                        setCarName(
                            data?.data?.vinDetails?.vehicleSnap?.["year"]?.value +
                            " " +
                            data?.data?.vinDetails?.vehicleSnap?.["make"]?.value +
                            " " +
                            data?.data?.vinDetails?.vehicleSnap?.["model"]?.value
                        );
                        setIssHidden(true);
                    }
                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [enterpriseId, skuName, dealerVinId]);


    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => {
                toast.success("Link Copied Successfully");
                setTimeout(() => {
                    setShareLink(window.location.href);
                    setIsCopied(false);
                }, 1200);
            }, 1200);
            return () => clearTimeout(timer);
        }
    }, [copied]);

    // const downloadVideo = async (enterprise_id_download, sku_id_download, sessionId) => {
    //     const queryParams = new URLSearchParams(window.location.search);
    //     const sourceValue = queryParams.get('sku_name') ? 'WEBSITE' : 'IFRAME';
    //     let retryCount = 0;
    //     const maxRetries = 5;
    //     const offsetDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
    //     const time = offsetDate.toISOString()?.slice(0, -1);

    //     const makeRequest = async () => {
    //         try {
    //             if (retryCount === 0) {
    //                 setIsDownloading(true);
    //             }

    //             amplitudeEvents({
    //                 event: 'click_download',
    //                 customAmplitudeEvents: {
    //                     iframe_session_id: sessionId,
    //                     sku_id: sku_id_download,
    //                     enterprise_id: enterprise_id_download,
    //                     time: time,
    //                     skuName: sku_id_download
    //                 }
    //             });

    //             const res = await centralAPI.handleGetRequest(
    //                 `${process.env.REACT_APP_BASEURL_API_SPYNE}/spin/download-video`,
    //                 {
    //                     enterprise_id: enterprise_id_download,
    //                     sku_id: sku_id_download,
    //                     source: sourceValue,
    //                 }
    //             );

    //             const statusCode = parseInt(res.statusCode, 10);
    //             if (statusCode === 102) {
    //                 toast.info('Download in Progress...', {
    //                     autoClose: 3000,
    //                     position: 'bottom-center'
    //                 });
    //             } else if (statusCode === 500 || statusCode === 404) {
    //                 toast.error('Video Download Failed...', {
    //                     autoClose: 3000,
    //                     position: 'bottom-center'
    //                 });
    //                 setIsDownloading(false);
    //                 return;
    //             }

    //             const videoUrl = res.data.output_video_url;
    //             if (!videoUrl) {
    //                 if (retryCount < maxRetries) {
    //                     retryCount++;
    //                     await new Promise(resolve => setTimeout(resolve, 20000));
    //                     return makeRequest();
    //                 } else {
    //                     toast.error('Video URL not available after multiple attempts.');
    //                     setIsDownloading(false);
    //                     return;
    //                 }
    //             }

    //             const link = document.createElement('a');
    //             link.href = videoUrl;
    //             const fileExtension = videoUrl?.split('.')?.pop()?.toLowerCase();
    //             link.download = `360_video_${sku_id_download}.${fileExtension}`;

    //             const iframe = document.createElement('iframe');
    //             iframe.style.display = 'none';
    //             document.body.appendChild(iframe);

    //             let checkDownloadInterval = setInterval(() => {
    //                 try {
    //                     if (!iframe.contentWindow || !iframe.contentWindow.document.body) {
    //                         clearInterval(checkDownloadInterval);
    //                         document.body.removeChild(iframe);
    //                         setTimeout(() => {
    //                             setIsDownloading(false);
    //                         }, 1000);
    //                     }
    //                 } catch (e) {
    //                     clearInterval(checkDownloadInterval);
    //                     document.body.removeChild(iframe);
    //                     setTimeout(() => {
    //                         setIsDownloading(false);
    //                     }, 1000);
    //                 }
    //             }, 1000);

    //             iframe.contentWindow.location.href = videoUrl;

    //             setTimeout(() => {
    //                 if (checkDownloadInterval) {
    //                     clearInterval(checkDownloadInterval);
    //                     setIsDownloading(false);
    //                 }
    //             }, 30000);

    //         } catch (error) {
    //             console.error('Error downloading video:', error);
    //             toast.error('Download Failed');
    //             setIsDownloading(false);
    //         }
    //     };

    //     try {
    //         await makeRequest();
    //     } catch (error) {
    //         console.error('Download failed:', error);
    //         setIsDownloading(false);
    //     }
    // };

    const shareOptions = [
        // {
        //     icon: 'https://spyne-static.s3.us-east-1.amazonaws.com/download.svg',
        //     label: 'Download'
        // },
        {
            icon: 'https://spyne-static.s3.us-east-1.amazonaws.com/email.svg',
            label: 'Email'
        },
        {
            icon: 'https://spyne-static.s3.us-east-1.amazonaws.com/Facebook.svg',
            label: 'Facebook'
        },
        {
            icon: 'https://spyne-static.s3.us-east-1.amazonaws.com/Instagram.svg',
            label: 'Instagram'
        },
        {
            icon: 'https://spyne-static.s3.us-east-1.amazonaws.com/WhatsApp.png',
            label: 'WhatsApp'
        }
    ];


    const filteredOptions = shareOptions.filter(option =>
        isDownload || option.label !== 'Download'
    );

    const handleShareOrDownload = async (label) => {
        setShareCount(shareCount + 1);
        // if (label.toLowerCase() === 'download') {
        //     setIsDownloading(true);
        //     try {
        //         await downloadVideo(enterpriseid_for_download, skuId_for_download);
        //     } catch (error) {
        //         console.error("Error downloading video: ", error);
        //     } finally {
        //         setIsDownloading(false);
        //     }
        // } else {

        switch (label.toLowerCase()) {
            case "copy":
                try {
                    await navigator.clipboard.writeText(url);
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 1000);
                } catch (error) {
                    console.error("Failed to copy link: ", error);
                }
                break;

            case "email":
                const emailSubject = `${vinData} - ${carName}`;
                const emailBody = `Check out this vehicle: ${url}`;
                const mailtoLink = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
                window.location.href = mailtoLink;
                break;

            case "facebook":
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
                    "_blank"
                );
                break;

            case "instagram":
                window.open(
                    `https://www.instagram.com/sharer.php?u=${encodeURIComponent(url)}&text=Check this out!`,
                    "_blank"
                );
                break;

            case "whatsapp":
                window.open(
                    `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
                    "_blank"
                );
                break;

            default:
                // console.log(`Sharing via ${label}`);
                break;
        }
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareLink)
        setIsCopied(true);
    };

    return (
        <>
            <div
                className={`
                    absolute inset-0 
                    bg-[#00000066] 
                    flex items-center 
                    justify-center 
                    z-[9999] 
                    cursor-default
                    transition-opacity 
                    duration-300 
                    ${isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
                `}
                onClick={onClose}
            >
                <div
                    className={`
                        bg-[#FFFFFF] 
                        w-full 
                        mx-4
                        ${clientHeight < 500 ? 'max-w-[500px]' : 'max-w-[600px]'}
                        rounded-3xl 
                        ${clientHeight < 500 ? 'p-[16px]' : 'p-[24px]'}
                        transform 
                        transition-all 
                        duration-500 
                        ease-out 
                        ${isVisible
                            ? 'translate-y-0 scale-100 opacity-100'
                            : 'translate-y-20 scale-95 opacity-0'
                        }
                    `}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className='relative flex justify-between w-full h-6'>
                        <div className='flex items-center'>
                            <div className={`mx-1 ${clientHeight < 500 ? 'h-[20px] w-[20px]' : 'h-[26px] w-[26px]'}`}>
                                <img
                                    src='https://spyne-static.s3.us-east-1.amazonaws.com/share.svg'
                                    alt="Share icon"
                                    className="w-full h-full"
                                />
                            </div>
                            <p className={`mx-4 text-[#023E8A] font-bold ${clientHeight < 500 ? 'text-[14px]' : 'text-[18px]'}`}>
                                Share with
                            </p>
                        </div>
                        <button onClick={onClose}>
                            <img
                                src='https://spyne-static.s3.us-east-1.amazonaws.com/close+icon.svg'
                                className={`${clientHeight < 500 ? 'w-[12px] h-[12px]' : 'w-[15.33px] h-[15.12px]'}`}
                                alt="Close icon"
                            />
                        </button>
                    </div>

                    {/* Vehicle Details */}
                    {!loading && (
                        <div className={`bg-white border border-[#83BCFF] w-full ${clientHeight < 500 ? 'h-[60px] mt-4' : 'h-[88px] mt-8'
                            } rounded-lg shadow-md flex items-center`}>
                            <div className={`${clientHeight < 500 ? 'w-[100px]' : 'w-[154px]'
                                } h-full mr-4 overflow-hidden rounded-lg`}>
                                <img
                                    src={vehicleImage || 'https://spyne-static.s3.us-east-1.amazonaws.com/console/InputContainer.png'}
                                    alt={carName || 'Demo Car'}
                                    className="w-full h-full object-cover"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                            <div className="flex flex-col mx-1">
                                <div className={`font-bold text-[#023E8A] w-full flex start ${clientHeight < 500 ? 'text-sm' : 'text-lg'
                                    }`}>
                                    {carName || 'Demo Car'}
                                </div>
                                <div className={`flex text-[#023E8A] font-bold ${clientHeight < 500 ? 'mt-0.5 text-xs' : 'mt-1 text-base'
                                    }`}>
                                    <span className="text-[#00000080] font-bold">VIN:</span> {skuName || 'Demo VIN'}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Share Options */}
                    <div className="flex justify-around w-full mt-12">
                        {filteredOptions.map((option, index) => (
                            <div
                                key={index}
                                className={`${clientHeight < 500
                                    ? "w-[44px] h-[44px] bg-[#F7F7F7] rounded-[80px] flex justify-center items-center cursor-pointer hover:bg-[#e0e0e0] transition"
                                    : "w-[64px] h-[64px] bg-[#F7F7F7] rounded-[80px] flex justify-center items-center cursor-pointer hover:bg-[#e0e0e0] transition"
                                    }`}
                                onClick={() => handleShareOrDownload(option?.label)}
                            >
                                <img
                                    src={option?.icon}
                                    className={`${isDownloading && option?.label.toLowerCase() === "download"
                                        ? "svg-animation"
                                        : ""
                                        }`}
                                    style={{
                                        ...(clientHeight < 500
                                            ? { width: "30px", height: "30px" }
                                            : { width: "30px", height: "30px" })
                                    }}

                                    alt={option?.label}
                                />
                            </div>
                        ))}
                    </div>

                    <div className='flex justify-around w-full mt-2'>
                        {filteredOptions.map((option, index) => (
                            <p
                                key={index}
                                className={`${clientHeight < 500
                                    ? "w-[64px] text-center text-[#0000004D] text-sm"
                                    : "w-[64px] text-center text-[#0000004D]"
                                    }`}
                            >
                                {option?.label}
                            </p>
                        ))}
                    </div>


                    {/* Share Link Section */}
                    <div className={`w-full ${clientHeight < 500 ? 'mt-4' : 'mt-8'} justify-center`}>
                        <p className={`w-full text-center text-[#000000B2] font-bold ${clientHeight < 500 ? 'text-sm' : 'text-base'
                            }`}>
                            or share with link
                        </p>
                    </div>

                    {/* Link Copy Section */}
                    <div className={`mx-auto mt-1 bg-[#F8F9FA] rounded-[8px] flex items-center justify-between ${clientHeight < 500 ? 'h-[40px] max-w-[90%]' : 'h-[48px] max-w-[520px]'
                        }`}>
                        <p className={`text-gray-700 p-[13px] text-ellipsis overflow-hidden whitespace-nowrap ${clientHeight < 500 ? 'text-sm' : 'text-base'
                            }`}>
                            {shareLink}
                        </p>
                        <button
                            onClick={(e) => {
                                // Add visual feedback on click
                                const button = e.currentTarget;
                                button.classList.add('bg-gray-300', 'scale-95');

                                // Reset after animation completes
                                setTimeout(() => {
                                    button.classList.remove('bg-gray-300', 'scale-95');
                                }, 200);

                                handleCopyLink();
                            }}
                            className="hover:bg-gray-200 p-2 rounded-full transition transform duration-150 active:bg-gray-300 active:scale-95"
                        >
                            <img
                                src='https://spyne-static.s3.us-east-1.amazonaws.com/iconamoon_copy.svg'
                                className={`mr-4 ${clientHeight < 500 ? 'w-[20px] h-[20px]' : 'w-[24px] h-[24px]'}`}
                                alt="Copy link"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShareModal;